export default {
  groupName: 'ford-us-tier2',
  appName: 'Ford US Tier2',
  isAuto: true,
  image: 'ford.png',
  baseRoute: '/ford-us-tier2',
  description:
    'Ford - US Non-Luxury Tier 2 Advertising Dashboard (Starting Jan 2019)'
}
